import PlayIcon from '@/modules/Education/assets/icons/play.svg?react';
import { VideoMediaProps } from '@/modules/Education/types/Education.type';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import VideoPlayer from '../VideoPlayer';

export default function VideoMedia({ src, cover, title }: VideoMediaProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (isPlaying) {
    return (
      <Box width="100%" height="100%" position="relative">
        <VideoPlayer src={src} />
      </Box>
    );
  }

  return (
    <Box width="100%" height="100%" position="relative">
      <img
        src={cover}
        alt={title}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <Box position="absolute" inset="0" bg="rgba(0,0,0,0.15)" />
      <Box
        onClick={() => setIsPlaying(true)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="56px"
        height="56px"
        borderRadius="full"
        cursor="pointer"
        zIndex="1"
      >
        <PlayIcon />
      </Box>
    </Box>
  );
}
